module.exports = __webpack_public_path__ + "fonts/titania_4158e631834468389bd6be26816e5060.ttf";